import Login from './login';
import Search from './search';
import Minicart from './minicart';
import Accordion from './accordion';
import CookieCheck from './cookie.js';
import WishlistAdd from './wishlist';
import Seo from './seo';
import phonePrefix from './phonePrefix';
import LocaleSelector from './localeSelector';
import EnhancedSeo from '../enhancedSeo';
import Business from './b2b';
import HeaderStrip from './header';
import Plugins from './plugins';

class common {
  run() {
    this.mobileMenu();
    this.footerMenu();
    this.submitNewsletter();
    Login.login();
    Search.run();
    Minicart.run();
    Accordion.run();
    CookieCheck.cookieSid();
    WishlistAdd.run();
    Seo.run();
    this.loginToggle();
    this.loginMobileToggle();
    this.appInStoreDropdown();
    this.logoutAction();
    this.toolTipManage()

    EnhancedSeo.clickMobileFooterMenu([
      ".mobile-pane-footer",
      "a",
      "data-icon-name"
    ]);
    EnhancedSeo.clickOnCookieBanner([".cookie-alert", "a", "button"]);
    EnhancedSeo.clickCreateAccountHeaderPopup([".header-popup-footer", "a"]);
    this.setStoreLocatorUrlFooter();
    this.disableCopyPastePasswordInputFields();
    Business.init();
    phonePrefix.run();
    this.hideShowPassword();
  }


  mobileLoginForgotPassword(){
    $('.mobile-login .forgotpassword-link').on('click', () => {
      $('.close-login-popup').trigger('click');
      Login.resetPassword();
    });
  }

  hideShowPassword(){

    $('[id*="password"], [id*="Password"]').on('input', function() {
      var inputVal = $(this).val();
      if (inputVal.length > 0) {
        if($(this).attr('type')==='password'){
          $(this).siblings('.show-pass').removeClass('hide');
        }else{
          $(this).siblings('.hide-pass').removeClass('hide');
        }
      } else {
        $(this).siblings('.hide-pass').addClass('hide');
        $(this).siblings('.show-pass').addClass('hide');
      }
    });

    $('[id*="password"], [id*="Password"]').parent().find('.show-pass').click(function () {
      $(this).addClass('hide');
      $(this).siblings('[id*="password"], [id*="Password"]').attr('type', 'text');
      $(this).siblings('.hide-pass').removeClass('hide');
      Seo.passwordInteractionEvent('show');
    })

    $('[id*="password"], [id*="Password"]').parent().find('.hide-pass').click(function () {
      $(this).addClass('hide');
      $(this).siblings('[id*="password"], [id*="Password"]').attr('type', 'password');
      $(this).siblings('.show-pass').removeClass('hide');
      Seo.passwordInteractionEvent('hide');
    })

  }

  mobileMenu() {
    $(".nav.level-1 > li").data("counter", 0);
    $(".nav.level-1 > li").on("touchstart mouseenter focus", e => {
      let counter = parseInt($(e.currentTarget).data("counter"), 10);
      $(".nav.level-1 > li").data("counter", 0);

      if (e.type === "touchstart") {
        if (!counter) {
          counter++;
          $(e.currentTarget).data("counter", counter);
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }
    });

    // if (['small', 'medium'].indexOf(Foundation.MediaQuery.current) === -1) {
    //     return;
    // }

    const $menuPaneContainer = $(".mobile-pane-content");

    $(".mobile-menu a.has-submenu").click(event => {
      $(event.currentTarget).toggleClass("open");
      $(event.currentTarget)
        .next(".mobile-submenu")
        .slideToggle();

      const $scrollTo = $(event.currentTarget).parent();
      $menuPaneContainer.animate({
        scrollTop:
          $scrollTo.offset().top -
          $menuPaneContainer.offset().top +
          $menuPaneContainer.scrollTop()
      });
    });

    $(".mobile-menu").on("click", ".level-1", event => {
      event.stopPropagation();
      var dataLayerObject = {
        event: "asyncAction",
        gaHitType: "event",
        event_category: "menu",
        event_action: event.currentTarget.name,
        event_label: "only_first_level"
      };

      if (typeof dataLayer !== "undefined") {
        dataLayer.push(dataLayerObject);
      }
    });

    $(".mobile-submenu").on("click", ".level-2", event => {
      event.stopPropagation();
      var parentCat = $(event.currentTarget)
        .closest(".mobile-level-1")
        .find(".has-submenu")
        .attr("name");
      var dataLayerObject = {
        event: "asyncAction",
        gaHitType: "event",
        event_category: "menu",
        event_action: parentCat,
        event_label: event.currentTarget.innerText
      };

      if (typeof dataLayer !== "undefined") {
        dataLayer.push(dataLayerObject);
      }
    });

    $(".mobile-submenu").on("click", ".level-3", event => {
      event.stopPropagation();
      var parentCat = $(event.currentTarget)
        .closest(".mobile-level-1")
        .find(".has-submenu")
        .attr("name");
      var cat = $(event.currentTarget)
        .closest(".mobile-level-2")
        .find(".has-submenu")
        .attr("name");
      var dataLayerObject = {
        event: "asyncAction",
        gaHitType: "event",
        event_category: "menu",
        event_action: parentCat,
        event_label: cat + "/" + event.target.innerText
      };

      if (typeof dataLayer !== "undefined") {
        dataLayer.push(dataLayerObject);
      }
    });

    $("#toggle-mobile-menu, #close-mobile-menu").click(event => {
      $("body").toggleClass("menu-visible");
      $("body").removeClass("login-popup-visible");
    });

    $(document).ready(() => {
      let menuList = $('.nav.level-1');
      let mobileMenu = $('.mobile-menu');
      $.ajax({
        url: menuList.data('includeGiftCardMenu'),
        method: 'GET',
        success: (data) => {
          if(!data.position && data.position !== 0){
            menuList.append(data.template);
            mobileMenu.append(data.templateMobile)
          } else if(data.position === 0) {
            menuList.prepend(data.template);
            mobileMenu.prepend(data.templateMobile)
          } else {
            $(`.nav.level-1>li:nth-child(${data.position})`).after(data.template);
            $(`.mobile-menu>li:nth-child(${data.position})`).after(data.templateMobile);
          }
        }
      })
    });
  }

  footerMenu() {
    $("footer h6").click(event => {
      if (["small", "medium"].indexOf(Foundation.MediaQuery.current) > -1) {
        $(event.currentTarget).toggleClass("open");
        $(event.currentTarget)
          .next(".menu-footer")
          .slideToggle();
      }
    });
  }

  submitNewsletter() {
    $(".newsletterfooterform").submit(e => {
      e.preventDefault();

      var formHelpers = require("../util/formErrors");
      var $form = $(e.currentTarget);
      var action = $form.attr("action");

      var button = $form.find(".newslettersubmit");
      $(button).attr("disabled", true);

      $.ajax({
        url: action,
        type: "post",
        data: $form.serialize(),
        success: response => {
          formHelpers.clearPreviousErrors($form);
          var dataLayerObject;

          if (response.success) {
            $form.find("input[name$=_email]").val("");
            if (response.alreadyRegistered) {
              var dataLayerObject = {
                event: "asyncAction",
                gaHitType: "event",
                event_category: "newsletter_subscription",
                event_action: "ko",
                event_label: response.errorMessage
              };
            } else {
              var dataLayerObject = {
                event: "asyncAction",
                gaHitType: "event",
                event_category: "newsletter_subscription",
                event_action: "ok"
              };
            }
            console.log(JSON.stringify(dataLayerObject));
            dataLayer.push(dataLayerObject);
            window.location.href = response.redirectUrl;
          } else {
            $(button).attr("disabled", false);
            dataLayerObject = {
              event: "asyncAction",
              gaHitType: "event",
              event_category: "newsletter_subscription",
              event_action: "ko",
              event_label: response.errorMessage
            };
            console.log(JSON.stringify(dataLayerObject));
            dataLayer.push(dataLayerObject);
            formHelpers.resetErrorList($form, response.error);
            formHelpers.loadFormErrors($form, response.error);
          }
        },
        error: () => {}
      });
    });

    $(".newsletterlocalization").click(e => {
      e.preventDefault();

      var formHelpers = require("../util/formErrors");
      var $form = $(".newsletterlocalizationform");
      var action = $form.attr("action");

      $.ajax({
        url: action,
        type: "post",
        data: $form.serialize(),
        success: response => {
          formHelpers.clearPreviousErrors($form);
          if (response.success) {
            $form.find("input[name$=_email]").val("");
            window.location.href = response.redirectUrl;
          } else {
            formHelpers.resetErrorList($form, response.error);
            formHelpers.loadFormErrors($form, response.error);
          }
        },
        error: () => {}
      });
    });
  }

  appInStoreDropdown() {
    const $storeDropdown = $(".js-app-popup-wrapper");
    $storeDropdown.on('click', (e) => {
      if (e.currentTarget.classList.contains('open')) {
        e.currentTarget.classList.remove('open');
      } else {
        e.currentTarget.classList.add('open');
      }
    })
  }

  logoutAction(){
    $('.js-log-out').on('click', () => {
      let loyaltyStatus = $('.user.header-popup-wrapper .loyalty-icon-text-account').data('loyalty-status');
      EnhancedSeo.loginLogoutEvent('logout', loyaltyStatus);
    });
  }

  loginToggle() {
    const $loginBtn = $(".header-popup-wrapper.user > a");
    const $loginBtnWrapper = $loginBtn.parent();

    $loginBtn.click(e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!$loginBtnWrapper) return;
      $('.header-tooltip-text').removeClass('visible');
      $loginBtnWrapper.toggleClass("open");
    });
  }

  loginMobileToggle() {
    const $loginBtn = $("a.open-popup");
    const $loginWrapper = $('.header-popup-wrapper.mobile-login');
    const $loginWrapperPopup = $loginWrapper.find('.header-popup');

    $loginBtn.click(e => {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (!$loginWrapper) return;

      const $loginPopUpBody = $loginWrapper.find('.header-popup-body');
      const url = $loginBtn.data('href');

      $loginPopUpBody.empty();

      if ($loginWrapperPopup) {
        $loginWrapperPopup.css("height", window.visualViewport.height + "px");
      }
      $loginWrapper.toggleClass("open loading");
      $('.header-tooltip-text').removeClass('visible');


      $.get(url, { mobileView: true }, data => {

        $loginPopUpBody.append(data);
        if(!$loginWrapper.hasClass('logged-user')){
          Plugins.foundation();
          Plugins.validator();
          Login.login();
          this.hideShowPassword();
          this.mobileLoginForgotPassword();

        }

        $("body").addClass("login-popup-visible");
        $("body").removeClass("menu-visible");
        $loginWrapper.toggleClass("loading");

      });

      $('.close-login-popup').click( e => {
        if ($loginWrapper.hasClass("open")) {
          $loginWrapper.removeClass("open");
          $("body").removeClass("login-popup-visible");
        }
      });
    });
  }

  setStoreLocatorUrlFooter() {
    $(document).ready(() => {
      let footerUrls = $(".footer-container a");
      let storelocator = $(".find-in-botique");
      let storelocatorname = storelocator.attr("data-storelocator-name");
      footerUrls.each((i, el) => {
        let currentTarget = $(el);
        if (
          currentTarget.attr("href") &&
          currentTarget.attr("href").indexOf(storelocatorname) != -1
        ) {
          currentTarget.attr("href", storelocator.attr("href"));
        }
      });
    });
  }

  disableCopyPastePasswordInputFields() {
    $(document).ready(() => {
      $("input[type=password]").on("cut copy paste", e => {
        e.preventDefault();
      });
    });
  }

  toolTipManage() {
    $(document).ready(function () {

      var $container = $('.wrapper-header-tooltip-text');
      if ($container.length === 0) return;

      const $tooltip = $container.find('.header-tooltip-text');
      const TOOLTIP_KEY = 'loyaltyTooltip';
      const EXPIRATION_TIME = parseInt($('.slot-duration-time').data('loyalty-tooltip-duration'));
      const AUTOHIDE_MS = parseInt($('.slot-hide-interval-time').data('loyalty-tooltip-hide-interval'));
      const now = Date.now();
      const stored = localStorage.getItem(TOOLTIP_KEY);
      const isTimed = $container.hasClass('tooltip--timed') && AUTOHIDE_MS !== 0;

      const showTooltip = () => {
        $tooltip.addClass('visible');
        if (!$tooltip.data('impression-sent')) {
          dataLayer.push({
            event: 'GAevent',
            eventCategory: 'myaccount_popup',
            eventAction: 'impression',
            eventLabel: 'Impression'
          });
          $tooltip.data('impression-sent', true);
        }
      };
      const hideTooltip = () => $tooltip.removeClass('visible');

      let firstVisitSession = false;
      let tooltipVisibleOnce = false;
      let shouldShow = false;

      if (!stored) {
        shouldShow = true;
        firstVisitSession = true;
      } else {
        try {
          const data = JSON.parse(stored);
          const diffDays = (now - data.shownAt) / (1000 * 60 );
          if (diffDays >= EXPIRATION_TIME) {
            shouldShow = true;
            firstVisitSession = true;
          }
        } catch (e) {
          shouldShow = true;
          firstVisitSession = true;
        }
      }

      if (shouldShow) {
        showTooltip();
        tooltipVisibleOnce = true;
        localStorage.setItem(TOOLTIP_KEY, JSON.stringify({ shownAt: now }));

        if (isTimed) {
          let hiddenTime_sec = AUTOHIDE_MS * 1000;
          setTimeout(hideTooltip, hiddenTime_sec);
        }

        let lastScrollY = $(window).scrollTop();
        $(window).on('scroll', function () {
          const currentScrollY = $(window).scrollTop();

          // Nasconde se scrolla giù
          if (currentScrollY > lastScrollY && tooltipVisibleOnce) {
            hideTooltip();
          }

          // Se scrolla su e siamo nella prima sessione → ricompare
          if (firstVisitSession && currentScrollY < lastScrollY && !$tooltip.hasClass('visible')) {
            showTooltip();
            if (isTimed) {
              setTimeout(hideTooltip, AUTOHIDE_MS);
            }
          }

          lastScrollY = currentScrollY;
        });
      }

      const DEBOUNCE_MS = 800;
      let lastClickTime = 0;

      $tooltip.find('a').on('click', function () {
        const nowClick = Date.now();
        if (nowClick - lastClickTime < DEBOUNCE_MS) return;
        lastClickTime = nowClick;

        const label = $(this).text().trim();
        dataLayer.push({
          event: 'GAevent',
          eventCategory: 'myaccount_popup',
          eventAction: 'click',
          eventLabel: label
        });
      });
    });
  }
}

const Common = new common();
export default Common;



// WEBPACK FOOTER //
// ./assets/scripts/components/common.js